var map = {
	"./automation.svg": "K36r",
	"./cloud.svg": "5nyt",
	"./cms.svg": "/4oa",
	"./cost.svg": "rBQz",
	"./customizable.svg": "8LSu",
	"./development.svg": "5AZr",
	"./eye.svg": "V6W5",
	"./maintanable.svg": "hMLW",
	"./ok.svg": "cam8",
	"./relational.svg": "8B+g",
	"./scalable.svg": "PfCS",
	"./self.svg": "t6YN",
	"./support.svg": "YxBL",
	"./time.svg": "MVP4",
	"./unit.svg": "5pdh",
	"./user.svg": "C4qO"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AuQN";